import Button from '~/components/Buttons/Button'
import useGetStartedEntryRoute from '~/get-started/hooks/useGetStartedEntryRoute'
import StartAnalytics from '~/analytics/start/startAnalytics'

interface LandingCtaButtonProps {
  analyticsLabel: string
  children: React.ReactNode
  className?: string
  uppercase?: boolean
}

export default function LandingCtaButton({
  analyticsLabel,
  children,
  className = '',
  uppercase = false,
}: LandingCtaButtonProps): React.ReactElement {
  const entryRoute = useGetStartedEntryRoute()

  const handleButtonClick = (): void => {
    StartAnalytics.logCtaClick('onboarding_cta', analyticsLabel)
  }

  return (
    <Button
      className={`bg-lime-200 text-black-rich text-md !font-bold ${
        uppercase ? 'uppercase' : ''
      } px-6 py-4 rounded-large shadow-v4-cta text-center leading-tight md:hover:scale-105 duration-300 ${className}`}
      href={entryRoute}
      noPadding
      onClick={handleButtonClick}
    >
      {children}
    </Button>
  )
}
